import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a741eeb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "p-fluid" }
const _hoisted_3 = {
  key: 0,
  class: "p-col-2 p-offset-2"
}
const _hoisted_4 = {
  key: 1,
  id: "pickerField",
  class: "p-col-6"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_info_button = _resolveComponent("info-button")!
  const _component_Button = _resolveComponent("Button")!
  const _component_string_picker = _resolveComponent("string-picker")!
  const _component_number_picker = _resolveComponent("number-picker")!
  const _component_category_picker = _resolveComponent("category-picker")!
  const _component_location_picker = _resolveComponent("location-picker")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "p-field p-grid",
          key: item
        }, [
          (item.type !== 'hidden')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _withDirectives((_openBlock(), _createBlock(_component_Button, {
                  class: _normalizeClass(["tooltipButton formBox", { required: item.required, notRequired: !item.required, pError: item.name === 'coords' ? (_ctx.$store.state.errors['x'] || _ctx.$store.state.errors['y']) : _ctx.$store.state.errors[item.name] }]),
                  tabindex: "-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_info_button),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t(item.title)), 1)
                  ]),
                  _: 2
                }, 1032, ["class"])), [
                  [
                    _directive_tooltip,
                    _ctx.$t(item.help),
                    void 0,
                    { right: true }
                  ]
                ])
              ]))
            : _createCommentVNode("", true),
          (item.type !== 'hidden')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (item.component === _ctx.ComponentEnum.StringPicker)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                      _createVNode(_component_string_picker, {
                        onSelect: _ctx.select,
                        value: item.value,
                        name: item.name,
                        placeholder: _ctx.$t(item.placeholder)
                      }, null, 8, ["onSelect", "value", "name", "placeholder"])
                    ]))
                  : _createCommentVNode("", true),
                (item.component === _ctx.ComponentEnum.NumberPicker)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                      _createVNode(_component_number_picker, {
                        name: item.name,
                        value: item.value,
                        onSelect: _ctx.select,
                        placeholder: _ctx.$t(item.placeholder)
                      }, null, 8, ["name", "value", "onSelect", "placeholder"])
                    ]))
                  : _createCommentVNode("", true),
                (item.component === _ctx.ComponentEnum.CategoryPicker )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      _createVNode(_component_category_picker, {
                        name: item.name,
                        clearable: item.clearable,
                        filter: item.filter,
                        api: item.api,
                        value: item.value == null ? item.defaultValue : item.value,
                        onSelect: _ctx.select
                      }, null, 8, ["name", "clearable", "filter", "api", "value", "onSelect"])
                    ]))
                  : _createCommentVNode("", true),
                (item.component === _ctx.ComponentEnum.LocationPicker)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                      _createVNode(_component_location_picker, {
                        name: item.name,
                        value: item.value,
                        onSelect: _ctx.select
                      }, null, 8, ["name", "value", "onSelect"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}